import { Alert } from 'antd';
import { downloadURI } from 'helpers/file';
import React from 'react';

export default function CreateExclusionJobInstruction() {
  return (
    <Alert
      description={
        <ul className="no-space">
          <li>
            For <b>Exclusion CSVs:</b>
            <ul className="no-space">
              <li>
                Exclusion CSV should be in <b>CSV format</b>
              </li>
              <li>
                Exclusion CSV should contain <b>email</b> column
              </li>
              <li>
                Download sample <b>Exclusion CSV</b>:{' '}
                <a
                  href="#"
                  onClick={() =>
                    downloadURI(
                      '/acg/phase-1-sample-exclusion-csv.csv',
                      'sample-exclusion-csv.csv',
                    )
                  }
                >
                  sample-exclusion-csv.csv
                </a>
              </li>
            </ul>
          </li>
          <li>
            For <b>Campaign CSVs:</b>
            <ul className="no-space">
              <li>
                Campaign CSV should be in <b>CSV format</b>
              </li>
              <li>
                Campaign CSV should contain those columns
                <ul className="no-space">
                  <li>
                    <b>email</b> - email address of the user
                  </li>
                  <li>
                    <b>email_domain</b> - email domain of the user. Example:
                    example@turing.com
                  </li>
                  <li>
                    <b>provider</b> - provider of the email. Example: Gmail,
                    Outlook, etc.
                  </li>
                  <li>
                    <b>rank_v2</b> - rank of the user
                  </li>
                  <li>
                    <b>organization_name</b> - company name of the user
                  </li>
                </ul>
              </li>
              <li>
                For each campaign CSV file, you can specify the Post Exclusion
                Criteria, including:
                <ul className="no-space">
                  <li>
                    <b>Domains</b> - domains to include in the campaign, reflect
                    <b>email_domain</b> column in the CSV
                  </li>
                  <li>
                    <b>Providers</b> - providers to include in the campaign,
                    reflect <b>provider</b> column in the CSV
                  </li>
                  <li>
                    <b>Ranks</b> - rank to include in the campaign, reflect
                    <b>rank_v2</b> column in the CSV
                  </li>
                  <li>
                    <b>Company Name Regexp</b> - Regular expression for the
                    company name to include in the campaign, reflect
                    <b>organization_name</b> column in the CSV
                  </li>
                </ul>
              </li>
              <li>
                Download sample <b>Campaign CSV</b>:{' '}
                <a
                  href="#"
                  onClick={() =>
                    downloadURI(
                      '/acg/phase-1-sample-campaign-csv.csv',
                      'sample-campaign-csv.csv',
                    )
                  }
                >
                  sample-campaign-csv.csv
                </a>
              </li>
            </ul>
          </li>
        </ul>
      }
      message={<b>Instructions:</b>}
      showIcon
      style={{ marginBottom: 16 }}
      type="info"
    />
  );
}
